import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-done",
  "use": "icon-done-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-done\"><path d=\"M18.9577 35.0846L8.43079 24.5577L10.0615 22.9462L18.9577 31.8424L37.9077 12.8732L39.5384 14.5039L18.9577 35.0846Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol